module Environments {
    module.directive("environmentnameunique", function () {
        return {
            require: "ngModel",
            link: function (scope: EnvironmentNameUniqueDirectiveScope, element, attributes, control: ng.INgModelController) {
                element.on("input", function () {
                    var inputValue = control.$viewValue;
                    if (inputValue) {
                        var duplicate = _.find(scope.environments, function (env:any) {
                            return env.name && env.name.toLowerCase() === inputValue.toLowerCase() && !env.isNew;
                        });
                        scope.$apply(function () {
                            if (!duplicate) {
                                scope.environmentEditorForm.environmentName.$setValidity("environmentnameunique", true, control);
                            } else {
                                scope.environmentEditorForm.environmentName.$setValidity("environmentnameunique", false, control);
                            }
                        });
                    }
                });
            }
        };
    });

    interface EnvironmentNameUniqueDirectiveScope extends ng.IScope{
        environments: IEnvironment[];
        environmentEditorForm: {
            environmentName:  ng.IFormController;
        }
    }
}